import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import useCurrentClinicId from "../../../../hooks/useCurrentClinic";
import useActiveVisit from "../../../../hooks/useActiveVisit";
import {
  BenchmarkInput,
  useBenchmarkSavingMutation,
} from "../../../../graphql/generated";
import { RootState } from "../../../../state/reducers";
import { FamilyHxAttributes } from "./FamilyHx";

const useFamilyHx = (token = "") => {
  const clinicId = useCurrentClinicId();
  const { visitId } = useActiveVisit(clinicId);
  const currentDate = new Date().toISOString().split("T")[0];
  const [visitToken, setVisitToken] = useState(token);
  const [createBenchmarkMutation] = useBenchmarkSavingMutation();
  const currentPhysician: string | undefined | null = useSelector(
    (state: RootState) => state.currentUser.currentUser?.givenName
  );
  const alternate = visitToken.concat(
    currentPhysician ?? "[Couldn't Fetch Physician]",
    currentDate
  );

  const benchmark = useCallback(
    (FamilyHx: FamilyHxAttributes[]) => {
      const benchmarkInput: BenchmarkInput = {
        benchmarkId: "DoctorEdits-Benchmark-".concat(visitId ?? alternate),
        socialHx: "",
        familyHx: JSON.stringify({ FamilyHx }),
        meds: "",
        habits: "",
        discMeds: "",
        MedWarn: "",
        pastMedicalHx: "",
        discPastMedicalHx: "",
        vaccine: "",
        obgyn: "",
        allergies: "",
      };
      console.log(benchmarkInput);
      createBenchmarkMutation({ benchmark: benchmarkInput })
        .then((response) => {
          console.log("[FAMILY HX] Mutation successful:", response);
        })
        .catch((error) => {
          console.error("[FAMILY HX] Mutation failed:", error);
        });
    },
    [createBenchmarkMutation, visitId, alternate]
  );

  return { benchmark, setVisitToken };
};

export default useFamilyHx;
